import { httpGet } from './http.service';

export class CategoryService {

    loadMainCategories() {
        return httpGet('/categories/main')
            .then(response => response.data)
    }

    loadCategories() {
        return httpGet('/categories')
            .then(response => response.data)
            .then(categories => {
                return categories.sort((a, b) => {
                  if (a.description < b.description) return -1;
                  if (a.description > b.description) return 1;
                  return 0;
                })
              })
    }
}